import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon, ZoomInIcon } from 'lucide-react';
import { activityPreviews, type ActivityPreview } from '../data/gallery';
export function LookInside() {
  const [active, setActive] = useState<ActivityPreview | null>(null);
  const reduce = useReducedMotion();
  return <section className="cube-grid border-t border-white/10 bg-navy-900" data-id="element-128" data-mp="25qp451civ1e4">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 sm:px-6 sm:py-20" data-id="element-129" data-mp="1rvmuq48gutwk">
        <div className="max-w-2xl" data-id="element-130" data-mp="1wozfu4dxsikk">
          <h2 className="text-2xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-131" data-mp="1wq0sgdalpd4e">
            A Real Look Inside the Activities.
          </h2>
          <p className="mt-3 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-132" data-mp="1mxcydqb09n9d">
            Every page is designed to give learners a clear task, visual support
            and a satisfying next step.
          </p>
        </div>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-133" data-mp="1dwwyeqth0y99">
          {activityPreviews.map(page => <li key={page.id} className="flex flex-col" data-id="element-134" data-mp="a4r3u1ayz6y9">
              <button type="button" onClick={() => setActive(page)} className="group relative block w-full overflow-hidden border border-white/10 bg-white transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(0,0,0,0.8)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-emerald" data-id="element-135" data-mp="6019whzvg2fz">
                <img src={page.image} alt={`${page.caption} activity page from ${page.volume}`} className="block w-full" data-id="element-136" data-mp="11zqfvyja13z" />
                <span className="pointer-events-none absolute right-3 top-3 flex h-8 w-8 items-center justify-center bg-navy-900/90 text-white opacity-0 transition-opacity duration-150 ease-out group-hover:opacity-100 group-focus-visible:opacity-100" data-id="element-137" data-mp="34r31yyocpbqv">
                  <ZoomInIcon className="h-4 w-4" aria-hidden="true" data-id="element-138" data-mp="13o28hpc3te3x" />
                </span>
              </button>
              <div className="mt-3" data-id="element-139" data-mp="18m3p83m251c8">
                <p className="font-pixel text-[10px] uppercase tracking-[0.1em] text-white sm:text-[11px]" data-id="element-140" data-mp="1den5x9g1kcl9">
                  {page.caption}
                </p>
                <p className="mt-1.5 text-xs text-brand-cyan" data-id="element-141" data-mp="1hfgqpty6tb9x">{page.volume}</p>
              </div>
            </li>)}
        </ul>
      </div>

      <AnimatePresence data-id="element-142" data-mp="pokcaowhaykj">
        {active ? <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-navy-900/90 p-4 sm:p-8" initial={reduce ? {} : {
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={reduce ? {} : {
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} role="dialog" aria-modal="true" aria-label={`${active.caption} preview`} onClick={() => setActive(null)} data-id="element-143" data-mp="ppc9u59mz6dg">
            <motion.div className="relative max-h-full w-full max-w-md overflow-auto" initial={reduce ? {} : {
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={reduce ? {} : {
          opacity: 0,
          scale: 0.98
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} onClick={event => event.stopPropagation()} data-id="element-144" data-mp="2k8ck15f5h2my">
              <img src={active.image} alt={`${active.caption} activity page from ${active.volume}`} className="block w-full bg-white" data-id="element-145" data-mp="21g05zlf4wcwz" />
              <button type="button" onClick={() => setActive(null)} aria-label="Close preview" className="absolute right-2 top-2 flex h-9 w-9 items-center justify-center bg-navy-900 text-white ring-1 ring-white/20 transition-colors duration-150 ease-out hover:bg-navy-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-emerald" data-id="element-146" data-mp="1rm055vqvxtu2">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-147" data-mp="3txksgs3md8lc" />
              </button>
            </motion.div>
          </motion.div> : null}
      </AnimatePresence>
    </section>;
}